import { render, staticRenderFns } from "./admin-education-types.vue?vue&type=template&id=d7a968d2&scoped=true"
import script from "./admin-education-types.vue?vue&type=script&lang=js"
export * from "./admin-education-types.vue?vue&type=script&lang=js"
import style0 from "./admin-education-types.vue?vue&type=style&index=0&id=d7a968d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a968d2",
  null
  
)

export default component.exports